/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemItemRelationPairWithRelations } from '../../models/item-item-relation-pair-with-relations';

export interface GetRelationPairsList$Params {
}

export function getRelationPairsList(http: HttpClient, rootUrl: string, params?: GetRelationPairsList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemItemRelationPairWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getRelationPairsList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ItemItemRelationPairWithRelations>>;
    })
  );
}

getRelationPairsList.PATH = '/admin/i2-relations/list';
